import styled from "../_snowpack/pkg/@emotion/styled.js";
import {t} from "../common/i18n.js";
import React from "../_snowpack/pkg/react.js";
import {
  getFormattedSize,
  getPageProduct,
  withAttrs
} from "../common/utils.js";
import Inline from "./inline.js";
import {colors, fontFamily, lineHeight} from "./theme.js";
import Input from "./input.js";
import Stack from "./stack.js";
import Radios from "./radios.js";
import {Text} from "./typo.js";
export default function ProductConfiguration(props) {
  const {page, onChange, values, article, error, readOnly, ...rest} = props;
  const product = getPageProduct(page);
  if (product.component === "model_product") {
    return null;
  }
  if (product.component === "standard_product") {
    const {cf_shipping_weight} = article;
    return /* @__PURE__ */ React.createElement(Container, {
      ...rest
    }, /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(ProductSize, {
      ...props
    }), cf_shipping_weight && /* @__PURE__ */ React.createElement(ConfigReadOnlyValue, null, t("Gewicht"), ": ", cf_shipping_weight, " ", t("g"))));
  }
  function ProductSize(props2) {
    const {article: article2} = props2;
    const {cf_inner_dimensions, cf_outer_dimensions} = article2;
    if (!cf_inner_dimensions && !cf_outer_dimensions)
      return null;
    const isSameDimension = cf_inner_dimensions === cf_outer_dimensions;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, isSameDimension ? /* @__PURE__ */ React.createElement(ConfigReadOnlyValue, null, t("Größe"), ": ", cf_inner_dimensions) : /* @__PURE__ */ React.createElement(React.Fragment, null, cf_inner_dimensions && /* @__PURE__ */ React.createElement(ConfigReadOnlyValue, null, t("Innenmaß"), ": ", cf_inner_dimensions), cf_outer_dimensions && /* @__PURE__ */ React.createElement(ConfigReadOnlyValue, null, t("Außenmaß"), ": ", cf_outer_dimensions)));
  }
  const {config} = product;
  const onConfigChange = (c) => {
    onChange({...values, ...c});
  };
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, config.map((c) => /* @__PURE__ */ React.createElement(Config, {
    key: c._uid,
    config: c,
    onChange: onConfigChange,
    values,
    error,
    readOnly
  })));
}
function Config(props) {
  const {config, ...rest} = props;
  if (config.component === "size_config") {
    return /* @__PURE__ */ React.createElement(SizeConfig, {
      config,
      ...rest
    });
  }
  if (config.component === "options_config") {
    return /* @__PURE__ */ React.createElement(OptionsConfig, {
      config,
      ...rest
    });
  }
  if (config.component === "group_config") {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, config.options.map((o) => /* @__PURE__ */ React.createElement(Config, {
      key: o._uid,
      config: o,
      ...rest
    })));
  }
  return null;
}
function OptionsConfig(props) {
  const {config, onChange, values, readOnly} = props;
  const {label, key, options} = config;
  const onOptionsChange = (e) => {
    const {value, name} = e.target;
    onChange({[name]: value});
  };
  const description = getReadOnlyOptionDescription(config, values);
  const text = getReadOnlyOptionText(config, values);
  return /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(SectionHeadline, null, label, " ", /* @__PURE__ */ React.createElement(React.Fragment, null, !readOnly && t("auswählen"))), readOnly ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ConfigReadOnlyValue, null, /* @__PURE__ */ React.createElement(Text, null, text), description && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Label, null, description)))) : /* @__PURE__ */ React.createElement(OptionsConfigRadios, {
    name: key,
    value: values[key],
    options,
    onChange: onOptionsChange
  }));
}
function getReadOnlyOptionText(config, values) {
  const option = config.options.find((o) => o.value === values[config.key]);
  return option?.text;
}
function getReadOnlyOptionDescription(config, values) {
  const option = config.options.find((o) => o.value === values[config.key]);
  return option?.description;
}
function SizeConfig(props) {
  const {config, onChange, values, error, readOnly} = props;
  const {dimensions, label} = config;
  const onFieldChange = (e) => {
    const {value, name} = e.target;
    onChange({[name]: parseInt(value, 10)});
  };
  const hasGlobalError = error && ["unitLength", "unitWidth"].includes(error.id);
  return /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(SectionHeadline, null, label ? label : t("Dimensionen"), " ", /* @__PURE__ */ React.createElement(React.Fragment, null, !readOnly && t("konfigurieren"))), readOnly ? /* @__PURE__ */ React.createElement(ConfigReadOnlyValue, null, getFormattedSize(config, values)) : /* @__PURE__ */ React.createElement(SizeConfigFields, null, dimensions.map((d) => {
    const {key, _uid, label: label2} = d;
    const value = values[key];
    const hasFieldError = error && error.errors && key in error.errors;
    const invalid = hasGlobalError || hasFieldError;
    return /* @__PURE__ */ React.createElement(SizeConfigFieldContainer, {
      key: _uid
    }, /* @__PURE__ */ React.createElement(SizeConfigField, {
      name: key,
      label: label2,
      value,
      invalid,
      onChange: onFieldChange
    }), hasFieldError && /* @__PURE__ */ React.createElement(ConfigError, null, error.errors[key].message));
  })), hasGlobalError && /* @__PURE__ */ React.createElement(ConfigError, null, error.message));
}
function SizeConfigField(props) {
  const {label, name, value, unit, invalid, onChange} = props;
  return /* @__PURE__ */ React.createElement(SizeConfigInputContainer, null, /* @__PURE__ */ React.createElement(SizeConfigInputInner, null, /* @__PURE__ */ React.createElement(SizeConfigLabel, null, label), /* @__PURE__ */ React.createElement(SizeConfigInput, {
    type: "number",
    name,
    onChange,
    value: value?.toString(),
    invalid: !!invalid
  }), /* @__PURE__ */ React.createElement(SizeConfigUnit, null, unit)));
}
const Container = styled.div``;
const SizeConfigInputContainer = styled(withAttrs(Stack, {spacing: "s"}))``;
const SizeConfigInputInner = styled(withAttrs(Inline, {spacing: "s"}))``;
const ConfigError = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  margin-top: 6px;
  line-height: ${lineHeight};
  color: ${colors.r6};
`;
const ConfigReadOnlyValue = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  line-height: ${lineHeight};
  font-weight: 500;
`;
const SizeConfigLabel = styled.div`
  width: 64px;
  font-family: ${fontFamily.secondary};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`;
const SizeConfigFields = styled(withAttrs(Stack, {spacing: "s"}))`
  margin-top: 8px;
`;
const SizeConfigFieldContainer = styled.div``;
const SizeConfigInput = styled(Input)`
  height: 24px;
  width: 100px;
  font-size: 14px;
`;
const SizeConfigUnit = styled.div`
  font-family: ${fontFamily.secondary};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`;
const OptionsConfigRadios = styled(withAttrs(Radios, {stack: true}))`
  margin-top: 8px;
  label {
    font-size: 14px;
  }
`;
const Section = styled(Stack)`
  --spacing: 8px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid ${colors.b6};
`;
const SectionHeadline = styled.div`
  font-family: ${fontFamily.secondary};
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  text-transform: uppercase;
`;
const Label = styled(Text)`
  font-size: 12px;
`;
